import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { UserInfo, Agent } from '../../../types';
import { RoleBadge } from '../../RoleBadge/RoleBadge';
import ChangePasswordModal from '../../ChangePasswordModal/ChangePasswordModal';
import './CurrentUserInfo.css';

interface CurrentUserInfoProps {
  user: UserInfo | null | undefined;
  agent?: Agent | null;
  title?: string;
  onLogout?: () => void;
}

export const CurrentUserInfo: React.FC<CurrentUserInfoProps> = ({ user, agent, title, onLogout }) => {
  const { t } = useTranslation();
  const [showChangePassword, setShowChangePassword] = useState(false);

  if (!user) {
    return null;
  }

  const getUserDisplayName = (): string => {
    if (user.firstName || user.lastName) {
      return `${user.firstName || ''} ${user.lastName || ''}`.trim();
    }
    return user.email;
  };

  return (
    <section className="sidebar-section user-info">
      <h3>{title || t('sidebar.userInfo')}</h3>
      <div className="sidebar-grid">
        <div className="sidebar-field">
          <label>{t('sidebar.userName')}</label>
          <input type="text" value={getUserDisplayName()} readOnly className="input-readonly" />
        </div>
        <div className="sidebar-field">
          <label>{t('sidebar.userEmail')}</label>
          <input type="text" value={user.email} readOnly className="input-readonly" />
        </div>
        {(agent || user.agentId) && (
          <div className="sidebar-field">
            <label>{t('sidebar.userAgent')}</label>
            <input type="text" value={agent?.name || user.agentId || ''} readOnly className="input-readonly" />
          </div>
        )}
        <div className="sidebar-field">
          <label>{t('sidebar.userRole')}</label>
          <div className="role-badge-container">
            <RoleBadge role={user.role} scope={user.scope} />
          </div>
        </div>
      </div>
      <button onClick={() => setShowChangePassword(true)} className="btn-change-password">
        <span className="material-icons">lock</span> {t('changePassword.changePassword')}
      </button>
      {onLogout && (
        <button onClick={onLogout} className="btn-logout">
          <span className="material-icons">logout</span> {t('common.logout')}
        </button>
      )}
      {showChangePassword && (
        <ChangePasswordModal onClose={() => setShowChangePassword(false)} />
      )}
    </section>
  );
};

export default CurrentUserInfo;
